<template>
  <div class="download-page" :style="{backgroundImage: 'url(' + backImg + ')'}">
    <div class="mengban">
      <div class="pc-header">
        <img :src="formSetting.logo" alt />
      </div>
      <div class="pc-content">
        <h1>{{formSetting.title}}</h1>
        <div class="left-box">
          <div style="margin-bottom: 20px;" @click="downloadApp(formSetting.ios_url)">
            <!-- <span class="download-img">
              <img src="img/IOS.png" />
            </span>-->
            <span>iOS下载</span>
          </div>
          <div style="width:40px;background:transparent"></div>
          <div @click="downloadApp(formSetting.android_url)">
            <!-- <span class="download-img">
              <img src="img/ANDROID.png" />
            </span>-->
            <span>Android下载</span>
          </div>
        </div>
        <div class="right-box" id="qrbox"></div>
        <!-- <div>
          <div class="pc-content-title">系统正在维护中</div>
          <div class="pc-content-main">请联系管理员，稍后重试</div>
          <div class="pc-content-tel">
            <span>联系方式</span>
            <span class="pc-content-tel_number">156-5698-2653</span>
          </div>
        </div>-->
      </div>
      <div class="phone-icon">
        <img :src="formSetting.logo" alt />
      </div>
      <div style="height: calc(100vh - 70px);">
        <div class="phone-all-content">
          <div class="phone-header">
            <h1>{{formSetting.title}}</h1>
          </div>
          <div class="phone-content">
            <div @click="downloadApp(formSetting.ios_url)">
              <!-- <span class="phone-img">
                  <img src="img/IOS.png" />
              </span>-->
              <span class="phone-font">iOS下载</span>
            </div>
            <div style="width:15px;background:transparent;box-shadow:none"></div>
            <div @click="downloadApp(formSetting.android_url)">
              <!-- <span class="phone-img">
                  <img src="img/ANDROID.png" />
              </span>-->
              <span class="phone-font">Android下载</span>
            </div>
          </div>
          <div class="phone-box-mobile" id="qrMobile"></div>
        </div>
      </div>
    </div>
    <!-- 判断微信环境下出现 -->
    <div class="wx-notice" v-if="isVchat">
      <div class="notice-detail">
        <div class="detail-spec">点击右上角选择浏览器打开</div>
        <div class="detail-rightIcon">
          <img src="img/jt.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAppWebsiteInfoPort } from '@/api/downloadApp/index'
import QRCode from 'qrcodejs2'
export default {
  data () {
    return {
      bgImg: '',
      formSetting: {
        logo: '',
        title: '智慧大学智慧校园APP',//标题
        mobile_background: '', //手机背景图
        pc_background: '', //PC背景图
        android_url: '', //android下载地址
        ios_url: '', //iOS下载地址
        domain_name: '',
        port: ""//端口
      },
      backImg: '',
      timeOutFuc: null,
      qrcode: null,
      qrcodeTwo: null,
      qrString: window.location.origin + '/platformManage/#/downloadMiddlePage',
      isVchat: false, // 是否是微信
    }
  },
  async created () {
    this.isVchat = this.getIsWxClient()
    await this.getAppWebsiteInfo()
    const width = document.body.clientWidth
    width <= 600 ? this.backImg = this.formSetting.mobile_background : this.backImg = this.formSetting.pc_background
    window.addEventListener("resize", this.resizeEventHandle);

    // this.initData()
  },
  mounted () {
    this.$nextTick(() => {
      this.initQrcode()
      this.initQrcodeTwo()
    })
  },
  destroyed () {
    window.removeEventListener("resize", this.resizeEventHandle);
  },
  methods: {
    // 判断是否是微信环境
    getIsWxClient () {
      var ua = window.navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) && ua.match(/MicroMessenger/i)[0] === 'micromessenger') {
        return true
      }
      return false
    },
    initQrcodeTwo () {
      const Vm = this
        ; (this.qrcodeTwo) && (this.qrcodeTwo = null)
      this.qrcodeTwo = new QRCode('qrMobile', {
        width: 102,
        height: 102,
        text: Vm.qrString,
        colorDark: '#000',
        colorLight: '#fff',
        correctLevel: QRCode.CorrectLevel.M
      })
    },
    downloadApp (url) {
      window.open(url)
    },
    resizeEventHandle () {
      if (this.timeOutFuc) {
        clearTimeout(this.timeOutFuc)
        this.timeOutFuc = null
      }
      this.timeOutFuc = setTimeout(() => {
        const width = document.body.clientWidth
        if (width <= 600) {
          if (this.backImg !== this.formSetting.mobile_background) {
            this.backImg = this.formSetting.mobile_background
          }
        } else {
          if (this.backImg !== this.formSetting.pc_background) {
            this.backImg = this.formSetting.pc_background
          }
        }
      }, 500)
    },
    initQrcode () {
      const Vm = this
        ; (this.qrcode) && (this.qrcode = null)
      this.qrcode = new QRCode('qrbox', {
        width: 132,
        height: 132,
        text: Vm.qrString,
        colorDark: '#000',
        colorLight: '#fff',
        correctLevel: QRCode.CorrectLevel.M
      })
    },
    clear () {
      this.qrcode.clear()
      this.qrcodeTwo.clear()
    },
    // async initData () {
    //   const {
    //     result, status, msg
    //   } = await getLicenseInfo({})
    //   if (status === 1000) {
    //     Object.assign(this.formSetting, result)
    //     return
    //   }
    //   return this.$message.error(msg)
    // }
    async getAppWebsiteInfo () {
      const {
        data: {
          result, status, msg
        }
      } = await getAppWebsiteInfoPort()
      if (status === 1000) {
        Object.assign(this.formSetting, result)
        console.log('result', result)
        return
      }
      return this.$message.error(msg)
    }
  }
}
</script>

<style lang='scss'>
body {
  min-width: 0;
}
.download-page {
  .wx-notice {
    z-index: 2003;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
    background-color: rgba(0, 0, 0, 0.5);
    .notice-detail {
      font-size: 0;
      padding-top: 20px;
      text-align: right;
      .detail-rightIcon {
        padding-left: 8px;
        padding-right: 20px;
        display: inline-block;
        visibility: top;
        img {
          width: 64px;
          // height: 64px;
        }
      }
      .detail-spec {
        padding-top: 36px;
        display: inline-block;
        vertical-align: top;
        text-align: center;
        font-weight: bold;
        line-height: 32px;
        font-size: 16px;
        color: #ffffff;
      }
    }
  }
  @media screen and (max-width: 600px) {
    // margin-bottom: 0vh;
    // background: goldenrod;
    .pc-content {
      display: none;
    }
    .pc-header {
      display: none;
    }
  }
  width: 100%;
  height: 100vh;
  // background-color: green;
  overflow: hidden;
  position: relative;
  // background: url("/img/licenseBig.png") no-repeat;
  background-repeat: no-repeat;
  background-size: cover;
  //   background: red;
  & > img {
    position: absolute;
    left: 0;
    right: 0;
    max-width: 100%;
    max-height: 100%;
  }
  h1 {
    color: #ffff;
    font-size: 32px;
    text-align: left;
    font-size: 51px;
    font-weight: 600;
    margin-bottom: 40px;
    text-align: center;
  }
  .phone-icon{
    @media screen and (max-width: 600px) {
      display: block;
    }
    display: none;
    height: 38px;
    margin: 16px 14px;
    img{
      max-height: 24px;
    }
  }
  .phone-all-content {
    display: none;
    @media screen and (max-width: 600px) {
      display: block;
      position: relative;
      top: calc(50% - 70px);
      transform: translateY(-50%);
    }
  }
  .phone-header {
    @media screen and (max-width: 600px) {
      display: block;
    }
    display: none;
    h1 {
      font-size: 24px;
      color: #ffffff;
      font-weight: 600;
      margin: 30px 0;
    }
  }
  .phone-content {
    @media screen and (max-width: 600px) {
      display: flex;
    }
    display: none;
    // display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    // position: fixed;
    width: 100%;
    height: 40px;
    // background: orangered;
    // bottom: 25px;
    // z-index: 999;
    @media screen and (max-width: 320px) {
      padding: 0;
    }
    & > div {
      width: 116px;
      height: 39px;
      border-radius: 6px;
      line-height: 39px;
      text-align: center;
      background: #008bff;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.29);

      // height: 100%;
      // background: forestgreen;
      // padding: 10px 15px;
      & > span {
        display: inline-block;
        vertical-align: top;
      }
    }
    .phone-img {
      width: 28px;
      height: 28px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .phone-font {
      width: calc(100% - 28px);
      text-align: center;
      font-size: 12px;
      color: white;
      height: 100%;
      line-height: 39px;
      font-weight: bold;
      @media screen and (max-width: 320px) {
        font-size: 12px;
      }
      // background: white;
    }
  }
  .phone-box-mobile {
    display: none;
    @media screen and (max-width: 600px) {
      background-color: #ffffff;
      display: block;
      width: 114px;
      height: 114px;
      padding: 6px;
      margin: 0 auto;
      margin-top: 40px;
      border-radius: 5px;
    }
  }
  .mengban {
    height: 100%;
    width: 100%;

    overflow: hidden;
    // background: url("~@/assets/mengban.png") no-repeat;
    //    background-size: cover;
  }
  .pc-header {
    width: 560px;
    height: 78px;
    // background: yellow;
    // background: gold;
    margin: 27px 23px 36px;
    img {
      //   max-width: 100%;
      max-height: 29px;
    }
  }
  .pc-content {
    // margin-top: 25vh;
    width: 683px;
    // margin: 0 auto;
    margin: 18vh 143px;
    color: white;
    font-weight: 500;
    text-align: left;
    // background: red;
    & > div {
      //   margin-right: 10vw;
      // display: inline-block;
      text-align: center;
      vertical-align: middle;
    }
    .left-box {
      text-align: center;
    }
    .left-box > div {
      height: 64px;
      display: inline-block;
      vertical-align: top;
      border-radius: 10px;
      background: #008bff;
      width: 202px;
      cursor: pointer;
      text-align: center;
      & > span {
        font-size: 24px;
        display: inline-block;
        vertical-align: middle;
        color: white;
        height: 100%;
        line-height: 64px;
      }
      .download-img {
        height: 30px;
        width: 30px;
        margin: 12px auto;
        img {
          height: 100%;
          width: 100%;
        }
      }
    }
    .right-box {
      height: 144px;
      width: 144px;
      padding: 6px;
      border-radius: 10px;
      background: #ffffff;
      margin: 50px auto;
    }
  }
}
</style>
